import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface Lead {
  id: string;
  contact_name: string;
  contact_email: string | null;
  contact_phone: string | null;
  property_address: string | null;
  property_city: string | null;
  property_state: string | null;
  property_zip: string | null;
  status: string;
  source: string | null;
  estimated_value: number | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
  converted_to_job_id: string | null;
  assigned_to: string | null;
}

export const useLeads = (orgId?: string) => {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadLeads = async () => {
    if (!orgId) {
      setLeads([]);
      setError(null);
      setLoading(false);
      return;
    }

    setLeads([]);
    setLoading(true);
    setError(null);
    
    try {
      const { data, error: fetchError } = await supabase
        .from('leads')
        .select('*')
        .eq('org_id', orgId)
        .order('created_at', { ascending: false });

      if (fetchError) throw fetchError;
      setLeads(data || []);
    } catch (err: any) {
      console.error("Error loading leads:", err);
      setError(err.message);
      toast.error("Failed to load leads");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLeads();
  }, [orgId]);

  return { leads, loading, error, refetch: loadLeads };
};
